
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.727 3.592a6.464 6.464 0 119.141 9.141 6.464 6.464 0 01-9.14-9.14zM15.061 2.4A8.15 8.15 0 103.656 14.045a.84.84 0 00-.575.246L.833 16.54a.843.843 0 001.192 1.192l2.248-2.248a.842.842 0 00.238-.724A8.15 8.15 0 0015.06 2.4z","clip-rule":"evenodd"}})])
          )
        }
      }
    